// ABOUTME: Orchestrates the pivot Excel export — builds sheet specs, hands them to the worker, downloads the blob.
// ABOUTME: Returns a promise (for showToastPromise) that settles when the file has been handed to the browser.
import { buildSheetSpecs } from "./pivotExportModel";

const XLSX_MIME = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

// Safe-ish filename from the report name + today's date.
const buildFileName = (currentReport) => {
    const base = (currentReport?.name || "pivot-export").replace(/[^\w-]+/g, "_").slice(0, 60) || "pivot-export";
    const d = new Date();
    const stamp = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
    return `${base}_${stamp}.xlsx`;
};

const triggerDownload = (buffer, fileName) => {
    const blob = new Blob([buffer], { type: XLSX_MIME });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    a.remove();
    // Revoke after the click has grabbed the object URL.
    setTimeout(() => URL.revokeObjectURL(url), 1000);
};

// Kicks off an export. Resolves { message } on success so the toast shows the ready copy; rejects with an Error.
export const runPivotExport = ({ data, currentReport, t, hidden = [] }) =>
    new Promise((resolve, reject) => {
        const sheets = buildSheetSpecs(data, currentReport, t, hidden);
        if (!sheets.length) {
            reject(new Error(t("export_no_data")));
            return;
        }

        let worker;
        try {
            worker = new Worker(new URL("../../../../webworkers/pivotExportWorker.js", import.meta.url));
        } catch (err) {
            reject(err);
            return;
        }

        worker.onmessage = (event) => {
            const { ok, buffer, error } = event.data || {};
            if (ok) {
                try {
                    triggerDownload(buffer, buildFileName(currentReport));
                    resolve({ message: t("export_ready") });
                } catch (err) {
                    reject(err);
                }
            } else {
                reject(new Error(error || t("export_failed")));
            }
            worker.terminate();
        };

        worker.onerror = (err) => {
            reject(err instanceof Error ? err : new Error(err?.message || t("export_failed")));
            worker.terminate();
        };

        worker.postMessage({ sheets });
    });
